import React from "react";
import { connect } from "react-redux";

import Suppliers from "./suppliers";
import Ledger from "./ledger";

import { setBreadcrumbs } from "reducers/view";

class StockItem extends React.Component {
  constructor() {
    super(...arguments);
    this.props.setBreadcrumbs([
      { name: "Stock", slug: "/stock" },
      {
        name: `Item: ${this.currentItem.name}`,
        slug: `/stock/${this.currentId}`,
      },
    ]);
  }

  get currentId() {
    return this.props.match.params.id ?? null;
  }

  get currentItem() {
    return this.props.all.find((item) => item.id === this.currentId);
  }

  render() {
    const stock = this.currentItem;

    if (this.currentItem) {
      return (
        <React.Fragment>
          <h1>{stock.name}</h1>
          <Ledger {...this.props} stock={stock} />
          <Suppliers {...this.props} stock={stock} />
        </React.Fragment>
      );
    }
    return null;
  }
}

export default connect(
  (state) => {
    return {
      all: state.stock.all,
    };
  },
  { setBreadcrumbs }
)(StockItem);
